import { Chip } from "@mui/material";
import { PASTEL_CHIP_BASE_SX } from "features/integrationsBeta/platformEnumUi";
import type { PdfJobStatus } from "features/pdfTools/pdfTools";
import { PDF_JOB_STATUS_CHIP_SX, PDF_JOB_STATUS_LABELS } from "./pdfJobUi";

export default function JobStatusChip({ status }: { status: PdfJobStatus }) {
  return (
    <Chip
      label={PDF_JOB_STATUS_LABELS[status] ?? status}
      size="small"
      sx={{
        ...PASTEL_CHIP_BASE_SX,
        minWidth: 92,
        ...(PDF_JOB_STATUS_CHIP_SX[status] as object),
      }}
    />
  );
}
